import * as React from 'react';

export interface ConfirmBillingPlanModalProps {
    isModalShown: boolean;
    confirmationText: string;
    onConfirm: () => void;
    onClose: () => void;
}

interface ConfirmModalState {
}

export class ConfirmationModal extends React.Component<ConfirmBillingPlanModalProps, ConfirmModalState> {
    constructor(props: ConfirmBillingPlanModalProps) {
        super(props);
        this.onConfirm = this.onConfirm.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    render() {
        const modalClassName = this.props.isModalShown ? 'modalBO show' : 'modalBO';
        return (
            <div className={modalClassName} id="confirmBillingPlan" tabIndex={-1} role="dialog" aria-labelledby="confirmBillingPlan" aria-hidden="true">
                <div>
                    <section>
                        <p>{this.props.confirmationText}</p>
                        <button
                            className="btn"
                            onClick={() => this.onConfirm()}
                        >Confirm
                        </button>
                    </section>

                    <a
                        onClick={() => this.onClose()}
                        data-dismiss="modal"
                        className="close"
                        aria-label="close"
                        href="javascript:void(0)"
                    >
                        Cancel
                    </a>
                </div>
            </div>
        );
    }

    private onConfirm() {
        this.props.onConfirm();
    }

    private onClose() {
        this.props.onClose();
    }
}


// WEBPACK FOOTER //
// ./src/backoffice/components/billing/BillingPlanConfirmModal.tsx